import { useEffect, useRef, useState } from 'react'
import { distanciaMetros } from './entrega'

// Direção do movimento (graus, 0 = norte) entre a posição anterior e a atual —
// é o que gira a seta da caixinha (2D) e a câmera (3D).
const rumo = (a, b) => {
  const rad = (g) => (g * Math.PI) / 180
  const y = Math.sin(rad(b.lng - a.lng)) * Math.cos(rad(b.lat))
  const x = Math.cos(rad(a.lat)) * Math.sin(rad(b.lat)) - Math.sin(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.cos(rad(b.lng - a.lng))
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360
}

// Calculado no próprio render (e não num efeito depois dele): assim a seta e a
// câmera já giram junto com a posição nova, não um ponto atrasadas.
export const useRumo = (position) => {
  const estado = useRef({ chave: null, anterior: null, graus: null })
  const chave = position ? `${position.lat},${position.lng}` : null
  const e = estado.current
  if (position && chave !== e.chave) {
    // Parado (menos de ~10 m): mantém a direção de antes em vez de girar à toa.
    if (e.anterior && distanciaMetros(e.anterior, position) > 10) e.graus = rumo(e.anterior, position)
    e.anterior = position
    e.chave = chave
  }
  return e.graus
}

// Re-renderiza a cada 5s pra "atualizado há X s" andar sozinho.
export const useAgora = () => {
  const [agora, setAgora] = useState(Date.now())
  useEffect(() => {
    const id = setInterval(() => setAgora(Date.now()), 5000)
    return () => clearInterval(id)
  }, [])
  return agora
}

